import React from 'react';
import { Hero } from '../components/Hero';
import { WhyUs } from '../components/WhyUs';
import { ByTheNumbers } from '../components/ByTheNumbers';
import { Services } from '../components/Services';
import { FAQ } from '../components/FAQ';
import { HowItWorks } from '../components/HowItWorks';
import { Reviews } from '../components/Reviews';
import { CtaBanner } from '../components/CtaBanner';
import { JsonLd, useSEO } from '../utils/seo';
export function Home() {
  useSEO({
    title: 'Gravel Delivery Seattle, WA | Same-Day Bulk Materials | 206Gravel',
    description: 'Order gravel, crushed rock, topsoil, bark, and drain rock online with dependable same-day and next-day delivery across Seattle, King County, and Pierce County.',
    path: '/'
  });
  return <main data-id="element-2746" data-mp="2dfdt3uligutr">
      <JsonLd data={{
      '@context': 'https://schema.org',
      '@type': 'LocalBusiness',
      name: '206Gravel',
      url: 'https://206gravel.com',
      telephone: '+1-206-619-3742',
      email: 'info@206gravel.com',
      priceRange: '$',
      address: {
        '@type': 'PostalAddress',
        addressLocality: 'Bonney Lake',
        addressRegion: 'WA',
        addressCountry: 'US'
      },
      areaServed: ['Seattle', 'Tacoma', 'Bellevue', 'King County', 'Pierce County'],
      description: 'Locally owned bulk gravel, rock, soil, bark, and aggregate delivery across King and Pierce counties.'
    }} data-id="element-2747" data-mp="3kvabslgem9v0" />
      <div className="dark" data-id="element-2748" data-mp="2hy714x9mv864">
        <Hero data-id="element-2749" data-mp="2hzi5ozawkjya" />
      </div>
      {/* The materials catalog sits directly under the hero. It used to run
          fourth, behind WhyUs and ByTheNumbers, which meant a customer who
          didn't already know their material had to scroll past two trust
          sections before seeing a single product photo. Browsing is the second
          thing the page offers now; the trust sections follow it. */}
      <Services data-id="element-2750" data-mp="1z6wa8g3wqve8" />
      <WhyUs data-id="element-2751" data-mp="1z9inmwdhc54d" />
      <ByTheNumbers data-id="element-2752" data-mp="1u8coogt87lme" />
      <FAQ data-id="element-2753" data-mp="1u7t9v8yvhdcl" />
      {/* Ordering process sits directly above the testimonials: answer the
          "how does this work?" question, then back it with social proof. */}
      <HowItWorks data-id="element-2754" data-mp="1kn3ckdomjr1k" />
      <Reviews data-id="element-2755" data-mp="1om2ia0i6jru2" />
      <CtaBanner data-id="element-2756" data-mp="1omkjlbjp8w8u" />
    </main>;
}